import { createStore } from "vuex";
import confirmation from './confirmation';
import auth from './auth';
import toast from './toast';

export default createStore({
  modules: {
    confirmation,
    auth,
    toast
  },
  state: {
    master: {
      cpd: {}
    },
    theme: 'blue'
  },
  mutations: {
    master(state, data){
      state.master = data;
    },
    theme(state, data){
      state.theme = data;
    }
  },
  actions: {
    theme({commit}, theme){
      if (!theme) theme = window.localStorage.getItem('theme');
      else {
        window.localStorage.setItem('theme', theme);
      }
      theme = theme || 'blue';
      document.querySelector('html').setAttribute('theme', theme);
      commit('theme', theme);
    }
  },
  getters: {}
});
